// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import * as operations from '../../redux/ducks/renameCampaignForm/operations'
import { translations, translateFunc } from '../../shared/localize'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
`
const FormHeader = styled.div`
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 10px;
`
const Header = styled.div`
  font-size: 14px;
  padding-bottom: 5px;
`
const Error: StyledComponent<Object, any, any> = styled.div`
  color: $alert-color;
  font-size: 14px;
  padding: 4px 0;
`
const InputGroup = styled.div`
  padding: 10px 0;
`

type Props = {|
  isOpened: boolean,
  errors: boolean,
  currentName: string,
  campaignName: string,
  locale?: string
|}

class RenameCampaignForm extends Component<Props> {
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.campaigns_table, { locale: props.locale })
  }

  renderErrors() {
    return <Error>{this.t('rename_campaign_errors_occured')}</Error>
  }

  render() {
    const { isOpened, currentName, campaignName, errors } = this.props

    const isValid = operations.validateName()

    return (
      <Modal open={isOpened} onClose={() => operations.closeForm()}>
        <Wrapper style={{ minWidth: 450 }}>
          <form>
            <FormHeader>
              {this.t('rename_campaign_form_header')} "{campaignName}"
            </FormHeader>
            <InputGroup>
              <Header>{this.t('rename_campaign_name_label')}</Header>
              <input
                value={currentName}
                id="t-RenameCampaignInput"
                className="input-item input-item_full-width"
                onChange={(el) => operations.inputNameForm(el.target.value)}
              />
              {errors && this.renderErrors()}
            </InputGroup>

            <InputGroup>
              <button
                type="submit"
                className="blue-button"
                onClick={(e) => {
                  e.preventDefault()
                  operations.saveRenaming()
                }}
                disabled={!isValid}
              >
                {this.t('rename_campaign_btn')}
              </button>
            </InputGroup>
          </form>
        </Wrapper>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return { ...state.renameCampaignForm }
}

export default connect<Object, Object, _, _, _, _>(mapStateToProps)(RenameCampaignForm)
